// web shim - fast image is a mobile-only optimization, just use Image on web
import { Image } from 'react-native';

Image.resizeMode = {
  contain: 'contain',
  cover: 'cover',
  stretch: 'stretch',
  center: 'center',
};

Image.priority = {
  low: 'low',
  normal: 'normal',
  high: 'high',
};

Image.cacheControl = {
  immutable: 'immutable',
  web: 'web',
  cacheOnly: 'cacheOnly',
};

Image.preload = Image.preload || (() => {});
Image.clearMemoryCache = () => Promise.resolve();
Image.clearDiskCache = () => Promise.resolve();

export default Image;
